import { useIntl, FormattedMessage } from 'react-intl';
import { FIRST_STEP } from '@/configs/fast-quote';
import ProductPick from '../product-pick';
import Confirmation from '../confirmation';

const useQuoteSteps = (
  totalStep: string,
  productType: TTypes,
  setActiveStep: any,
  isBuyNowFlow: boolean,
) => {
  const { formatMessage } = useIntl();

  let stepContents: any = [];

  const firstStepConfig = FIRST_STEP[productType];

  switch (Number(totalStep)) {
    case 3: // fast quote
      stepContents = [
        {
          title: <FormattedMessage {...firstStepConfig.title} />,
          content: (
            <firstStepConfig.Component
              productType={productType}
              nextStep="productSelection"
              changeActiveStep={setActiveStep}
              totalStep={totalStep}
            />
          ),
          key: firstStepConfig.key,
        },
        {
          title: formatMessage({ id: 'Product Selection' }),
          content: (
            <ProductPick
              productType={productType}
              nextStep="confirmation"
              changeActiveStep={setActiveStep}
            />
          ),
          key: 'productSelection',
        },
        {
          title: formatMessage({ id: 'Confirmation' }),
          content: <Confirmation productType={productType} />,
          key: 'confirmation',
        },
      ];
      break;
    case 2: // chosen plan
      stepContents = [
        {
          title: <FormattedMessage {...firstStepConfig.title} />,
          content: (
            <firstStepConfig.Component
              needCreateQuote={totalStep === '2'}
              productType={productType}
              nextStep="confirmation"
              changeActiveStep={setActiveStep}
            />
          ),
          key: firstStepConfig.key,
        },
        {
          title: formatMessage({ id: 'Confirmation' }),
          content: <Confirmation productType={productType} />,
          key: 'confirmation',
        },
      ];
      break;
    case 1: // chosen plan
      stepContents = [
        {
          title: <FormattedMessage {...firstStepConfig.title} />,
          content: (
            <firstStepConfig.Component
              needCreateQuote={totalStep === '1'}
              productType={productType}
              nextStep="application"
              changeActiveStep={setActiveStep}
              isBuyNowFlow={isBuyNowFlow}
            />
          ),
          key: firstStepConfig.key,
        },
      ];
      break;
    default:
  }

  return stepContents;
};

export default useQuoteSteps;
